
// // App JS

// import RegistrationPage from "./features/registration/pages/RegistrationPage";

// function App() {
//   return <RegistrationPage />;
// }

// export default App;

import AppRoutes from "./app/AppRoutes";

function App() {
  return <AppRoutes />;
}

export default App;